export const prepareCardsRow = (row) => {
  const { id, status, card, employee, time, transportation } = row;
  return {
    status: `${status}`,
    cardId: `${card?.id || '-'}`,
    transportation: `${transportation?.transportation?.content || '-'}`,
    employeId: `${employee?.id || '-'} ${employee?.user?.firstname || ''} ${employee?.user?.lastname || ''}`,
    time: `${new Date(time).toLocaleString('tr')}`,
  };
};
